import React from 'react';
import { formatPrice } from '../utils'; // Import formatPrice from utils

const SalesValuation = ({ valuation }) => {
  if (!valuation || !valuation.data) {
    return <p>No sales valuation data available.</p>;
  }

  return (
    <div className="sales-valuation-container">
      {valuation.data?.average && (
        <p className="valuation-price">
          £{formatPrice(valuation.data.average)}
        </p>
      )}

      {valuation.data?.['70pc_range'] && (
        <>
          <p className="estimated-bounds">
            Estimated bounds: £{formatPrice(valuation.data['70pc_range'][0])} - £{formatPrice(valuation.data['70pc_range'][1])}
          </p>
        </>
      )}
    </div>
  );
};

export default SalesValuation;
